import Swiper, { Pagination, EffectFade, Autoplay } from 'swiper'

const contentSliderInstances = [];
const contentSliderElements = document.querySelectorAll(
    '.block-content-slider .swiper, .block-multiple-teaser .swiper'
);

if (contentSliderElements.length) {
    for (let i = 0; i < contentSliderElements.length; i++) {
        contentSliderInstances[i] = {
            init: false,
            instance: null,
            element: contentSliderElements[i],
        };
    }
}

function sliderNoticesInit(slider) {
    const noticeToggles = slider.el.querySelectorAll('[data-notice-toggle]');

    noticeToggles.forEach((noticeToggle) => {
        noticeToggle.addEventListener('click', (event) => {
            const notice = slider.el.querySelector('[data-notice="' + event.target.getAttribute('data-notice-toggle') + '"]');
            slider.autoplay.stop();
            noticeToggle.ariaExpanded = true;
            notice.ariaExpanded = true;

            notice.addEventListener('click', () => {
                noticeToggle.ariaExpanded = false;
                notice.ariaExpanded = false;
                slider.autoplay.start();
            });
        });
    });
}

function contentSlidersInit() {
    if (contentSliderInstances.length === 0) {
        return;
    }

    for (let i = 0; i < contentSliderElements.length; i++) {
        if (contentSliderInstances[i].init) {
            continue;
        }

        contentSliderInstances[i].init = true;

        contentSliderInstances[i].instance = initializeContentSlider(contentSliderInstances[i].element, i % 2 === 0);

        if (768 > window.innerWidth) {
            sliderNoticesInit(contentSliderInstances[i].instance);
            continue;
        }

        const videos = contentSliderInstances[i].instance.el.querySelectorAll('[data-video-src]');

        if (0 < videos.length) {
            videos.forEach((video) => {
                video.src = video.getAttribute('data-video-src');
            });

            contentSliderInstances[i].instance.on('slideChange', (slider) => {
                videos.forEach((video) => {
                    video.pause();
                    video.currentTime = 0;
                });

                if (slider.slides[slider.activeIndex].matches('.swiper-video-slide')) {
                    slider.slides[slider.activeIndex].querySelector('[data-video-src]').play();
                }
            });
        }
    }
}
contentSlidersInit();
window.addEventListener('resize', contentSlidersInit);

function initializeContentSlider(slider) {
    const slides = slider.querySelectorAll('.swiper-slide');
    const titlePagination = slider.querySelectorAll('.pagination-titles');

    return new Swiper(slider, {
        modules: [ Pagination, EffectFade, Autoplay ],
        effect: 'fade',
        spaceBetween: 20,
        fadeEffect: {
            crossFade: true,
        },
        autoplay: {
            delay: 8000,
        },
        pagination: {
            el: '.swiper-pagination, .swiper-pagination-custom',
            clickable: true,
            renderBullet: function(index, className) {
                if (0 === titlePagination.length) {
                    return '<span class="swiper-pagination-bullet"></span>';
                }

                const title = slides[index].getAttribute('data-title');
                return '<div class="' + className + '"><span>' + title + '</span></div>';
            },
        },
    });
}
